import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["navMarker", "errorMarker", "title", "description", "use", "showDescription", "displayFullCardsOnMobile", "appearsIn", "showOverview", "size", "onItemClick"];
import { useState } from 'react';
import { CardsSection } from '../../cardsSection';
import { useAiRecommendationsForLearningContent } from '../../academyAi/academyAiHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecommendationsForLearningContent = _ref => {
  let {
      navMarker,
      errorMarker,
      title,
      description,
      use,
      showDescription,
      displayFullCardsOnMobile,
      appearsIn,
      showOverview,
      size = 'large',
      onItemClick
    } = _ref,
    item = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [maxCards, setMaxCards] = useState();
  const {
    recommendations,
    recommendationsLoading,
    recommendationsError
  } = useAiRecommendationsForLearningContent({
    item,
    size: maxCards,
    skip: !maxCards
  });
  return /*#__PURE__*/_jsx(CardsSection, {
    appearsIn: appearsIn || 'recommendations-for-entity',
    content: recommendations,
    description: description,
    displayFullCardsOnMobile: displayFullCardsOnMobile,
    error: recommendationsError,
    errorMarker: errorMarker,
    isLoading: recommendationsLoading,
    navMarker: navMarker,
    onItemClick: onItemClick,
    setMaxCards: setMaxCards,
    showDescription: showDescription,
    showOverview: showOverview,
    size: size,
    title: title,
    use: use
  });
};